// Datetime

export const ISO_DATE_FORMAT = 'YYYY-MM-DD'
export const DATE_FORMAT_DEFAULT = 'DD-MM-YYYY'
export const DATE_FORMAT_SLASH = 'DD/MM/YYYY'
export const DATE_FORMAT_LIST = [
  'DD/MM/YYYY',
  'D/M/YY',
  'DD/MM/YY',
  'D/M/YYYY',
  'D M YY',
  'DDMMYYYY',
]
export const TIME_FORMAT_LIST = ['HH:mm', 'H:m', 'H m']
export const HHhMM = 'HH[h]mm'
export const DD_MM = 'DD-MM'
export const MM_YYYY = 'MM/YYYY'
export const HH_mm = 'HH:mm'
export const YYYY_MM_DD_HH_mm = 'YYYY-MM-DD HH:mm'
export const YYYY_MM_DD = 'YYYY-MM-DD'
export const HH_mm_dd_MM_yyyy = 'HH:mm - dd/MM/yyyy'

// Roles
export const SUPER_ADMIN = 'SUPER_ADMIN'
export const EOFFICE_ADMIN = 'EOFFICE_ADMIN'
export const EOFFICE_USER = 'EOFFICE_USER'
export const SR_LEADER = 'SR_LEADER'
export const EOFFICE_CLERICAL = 'EOFFICE_CLERICAL'
export const EOFFICE_LEADER = 'EOFFICE_LEADER'
export const EOFFICE_SECRETARY = 'EOFFICE_SECRETARY'
export const SR_ADMIN = 'SR_ADMIN'
export const DIGITAL_SIGN = 'DIGITAL_SIGN'
export const DDPV = 'DDPV'

//Sign provider. TODO: refactor
export const DIGITAL_SIGN_PROVIDER = 'SAVIS'
export const DIGITAL_TYPE_SIGN = 'USER'
export const DIGITAL_TYPE_SIGN_USER = 'USER'
export const DIGITAL_TYPE_SIGN_SYSTEM = 'SYSTEM'

export const SIGN_PROVIDER = {
  SAVIS: 'SAVIS',
  FPT: 'FPT',
}

export const SIGN_TYPE = {
  USER: 'USER',
  SYSTEM: 'SYSTEM',
}

export const DIGITAL_SIGN_STATUS = {
  PENDING: 'PENDING',
  APPROVAL: 'APPROVAL',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  REJECT: 'REJECT',
}

export const ACTION_STATUS = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
}

export const SIGN_VISIBLE = {
  VISIBLE: 1,
  HIDE: 0,
}

// company code
export const TCY_HANG_HAI_VIET_NAM = 'CPN7451091748209'

// commands code

export const THU_DIEN_TU = 'CMD4351231218'
export const DAO_TAO_TRUC_TUYEN = 'CMD4351231217'
export const CLOUD_DU_LIEU = 'CMD4351234477'
export const CLOUD_FILE = 'CMD4351234490'
export const CLOUD_TALK = 'CMD4351234491'
export const CLOUD_EMAIL = 'CMD4351234492'
export const CLOUD_DOCUMENT = 'cloud_docment'
export const CLOUD_ACTIVITY = 'CMD4351234493'
export const LIEN_THONG = 'CMD4351230001'
export const TAI_CHINH_KE_TOAN = 'CMD4351234479'
export const VAN_PHONG_DIEN_TU = 'CMD4351231216'
export const VAN_PHONG_DIEN_TU_OLD = 'VAN_PHONG_DIEN_TU_OLD'
export const BAO_CAO_THONG_MINH = 'CMD4351234478'
export const NHAN_SU = 'CMD4351234480'
export const HR = 'HR'
export const KTT = 'KTT'
export const FAQ = 'FAQ'
export const DANH_GIA = 'DANH_GIA'

// ASSIGNEE_TYPE - Loại người phân phát
export const ASSIGNEE_TYPE = {
  USER: 'USER',
  DEPARTMENT: 'DPT',
  GROUP: 'GRP',
  HANDLER: 'PIC',
  FOLLOWER: 'VIEW',
  COMBINER: 'COOR',
  LEADER: 'LEAD',
  CREATE: 'CREATE',
  UNIT_LEADER: 'UNIT_LEADER',
  KT_KTNB: 'KT_KTNB',
  HDQT: 'HDQT',
  lanh_dao_vimc: 'lanh_dao_vimc',
  ban_kt_ktnb: 'ban_kt_ktnb',
  ban_dieu_hanh_hdqt_vimc: 'ban_dieu_hanh_hdqt_vimc',
  nddpv_vimc: 'nddpv_vimc',
  dvpt_vimc: 'dvpt_vimc',
  dv_cqvp_vimc: 'dv_cqvp_vimc',
  tgd_ptgd: 'tgd_ptgd',
  ban_kt_ktnb_vimc: 'ban_kt_ktnb_vimc',
  hdqt_vimc: 'hdqt_vimc',
  ban_dieu_hanh: 'ban_dieu_hanh',
  ban_pc_qtrr_ban_kt_ktnb_vimc: 'ban_pc_qtrr_ban_kt_ktnb_vimc',
  ban_cmnv_vimc: 'ban_cmnv_vimc',
  ban_pc_qtrr_vimc: 'ban_pc_qtrr_vimc',
  lanh_dao_ban: 'lanh_dao_ban',
  don_vi_thuc_hien_xu_ly_rui_ro_3: 'don_vi_thuc_hien_xu_ly_rui_ro_3',
  cqvp_I: 'cqvp_I',
  chuyen_vien_thuc_hien_cqvp_tuyen1: 'chuyen_vien_thuc_hien_cqvp_tuyen1',
  user_quan_tri_nhiem_vu: 'user_quan_tri_nhiem_vu',
  truong_ban_bao_cao_rui_ro: 'truong_ban_bao_cao_rui_ro',
  PAY: 'PAY',
  APPROVAL: 'APPROVAL',
  BUYER: 'BUYER',
  APPRAISER: 'APPRAISER',
  APPRAISER_1: 'APPRAISER_1',
  APPRAISER_2: 'APPRAISER_2',
  APPRAISER_3: 'APPRAISER_3',
  APPRAISER_4: 'APPRAISER_4',
  APPRAISER_5: 'APPRAISER_5',
  APPRAISER_6: 'APPRAISER_6',
  APPRAISER_7: 'APPRAISER_7',
  APPRAISER_8: 'APPRAISER_8',
  APPRAISER_9: 'APPRAISER_9',
  FOLLOWER_PROCUREMENT: 'FOLLOWER_PROCUREMENT',
}

export const SIGNATURE_TYPE = {
  PENDING: 'PENDING',
  APPROVAL: 'APPROVAL',
  REJECT: 'REJECT',
  DELETE: 'DELETE',
  USER: 'USER',
  SYSTEM: 'SYSTEM',
}

export const STATUS_DEFAULT = {
  PENDING: 'PENDING',
  COMPLETE: 'COMPLETE',
  INPROGRESS: 'INPROGRESS',
  REQUESTED: 'REQUESTED',
  CANCEL: 'CANCEL',
  APPROVAL: 'APPROVAL',
  REJECT: 'REJECT',
  DELETE: 'DELETE',
}
export const PROPOSAL_STATUS = {
  WAITING: 'WAITING',
  CREATED: 'CREATED',
  PENDING: 'PENDING',
  APPROVAL: 'APPROVAL',
  REJECT: 'REJECT',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
}

export const SHOPPING_STATUS = {
  CREATED: 'CREATED',
  REQUESTED: 'REQUESTED',
  APPROVED: 'APPROVED',
  REJECT: 'REJECT',
  BOUGHT: 'BOUGHT',
  PAID: 'PAID',
}

export const SHOPPING_USER_TYPE = {
  PROCESS: 'PROCESS',
  CREATED: 'CREATED',
  FOLLOW: 'FOLLOW',
}

export const POLICY_STATUS = {
  PENDING: 'PENDING',
  COMPLETE: 'COMPLETE',
}
export const CONSULT_STATUS = {
  PENDING: 'PENDING',
  COMPLETE: 'COMPLETE',
}
export const WORK_STATUS = {
  INTERNAL: 'INTERNAL',
  CONSULT: 'CONSULT',
  POLICY: 'POLICY',
  DOCUMENT: 'DOCUMENT',
  OTHER: 'OTHER',
  DEPLOY: 'DEPLOY',
  ELECTRONIC: 'ELECTRONIC',
  PENDING: 'PENDING',
  COMPLETE: 'COMPLETE',
  PROCEDURE: 'PROCEDURE',
  ALL_OTHER: 'INTERNAL,CONSULT,POLICY,OTHER,ELECTRONIC',
}
export const ELECTRONIC_DOCUMENT_STATUS = {
  PENDING: 'PENDING',
  VT_APPROVAL: 'VT_APPROVAL',
  LEAD_APPROVAL: 'LEAD_APPROVAL',
  REGIS_NUMBER: 'REGIS_NUMBER',
  RELEASE: 'RELEASE',
  CANCEL: 'CANCEL',
  READY: 'READY',
}
export const NOTIFICATION_STATUS = {
  OUTGOING: 'OUTGOING',
  INCOMING: 'INCOMING',
  ELEC_DOC: 'ELEC_DOC',
  WORK: 'WORK',
  TASK: 'TASK',
  VEHICLE: 'VEHICLE',
  LEAVE: 'LEAVE',
  LEAVE_ANNUAL: 'LEAVE_ANNUAL',
  LEAVE_ABNORMAL: 'LEAVE_ABNORMAL',
  LEAVE_NO_SALARY: 'LEAVE_NO_SALARY',
  SICK: 'SICK',
  SICK_OTHER: 'SICK_OTHER',
  OVERTIME_NORMAL: 'OVERTIME_NORMAL',
  OVERTIME_DAYOFF: 'OVERTIME_DAYOFF',
  OVERTIME_HOLIDAY: 'OVERTIME_HOLIDAY',
  // OVERTIME_CHAIRMAN: 'OVERTIME_CHAIRMAN',
  BUSINESS_TRIP: 'BUSINESS_TRIP',
  EVALUATE_MEMBER: 'EVALUATE_MEMBER',
  EVALUATE_LEADER: 'EVALUATE_LEADER',
  TIMEKEEPER: 'TIMEKEEPER',
  STATIONERY: 'STATIONERY',
  MEETING: 'MEETING',
  CONSULT: 'CONSULT',
  POLICY: 'POLICY',
  WORK_SCHEDULE: 'WORK_SCHEDULE',
  GENERAL: 'GENERAL',
  NEWS: 'NEWS',
  VBLT_DI: '0301',
  VBLT_DEN: '0300',
  PROPOSAL_SALARY: 'PROPOSAL_SALARY',
  INTERNAL_MESSAGE_INCOMING: 'INTERNAL_MESSAGE_INCOMING',
  INTERNAL_MESSAGE_OUTGOING: 'INTERNAL_MESSAGE_OUTGOING',
  INTERNAL_MESSAGE_INCOMING_REPLY: 'INTERNAL_MESSAGE_INCOMING_REPLY',
  INTERNAL_MESSAGE_OUTGOING_REPLY: 'INTERNAL_MESSAGE_OUTGOING_REPLY',
  RETIMEKEEPING: 'RETIMEKEEPING',
  OTHER: 'OTHER',
  PROPOSAL_ASSET: 'PROPOSAL_ASSET',
  PROCUREMENT: 'PROCUREMENT',
  INTERNAL_ASSESSMENT: 'INTERNAL_ASSESSMENT',
}
export const INTERNAL_DOCUMENT_INCOMING_STATUS = {
  PENDING: 'PENDING',
  INPROGRESS: 'INPROGRESS',
  COMPLETE: 'COMPLETE',
}
export const MISSION_STATUS = {
  PENDING: 'PENDING',
  INPROGRESS: 'INPROGRESS',
  COMPLETE: 'COMPLETE',
}
export const TYPE_STATUS = {
  ELECTRONIC_DOCUMENT: 'ELECTRONIC_DOCUMENT',
  PROPOSAL: 'PROPOSAL',
  PROPOSAL_ASSEST: 'PROPOSAL_ASSEST',
  PROPOSAL_TYPE: 'PROPOSAL_TYPE',
  POLICY: 'POLICY',
  CONSULT: 'CONSULT',
  WORK: 'WORK',
  NOTIFICATION: 'NOTIFICATION',
  INTERNAL_DOCUMENT_INCOMING: 'INTERNAL_DOCUMENT_INCOMING',
  MISSION: 'MISSION',
  WORK_SCHEDULE: 'WORK_SCHEDULE',
  SALARY: 'PROPOSAL_SALARY',
  SHOPPING: 'SHOPPING',
  INTERNAL_ASSESSMENT: 'INTERNAL_ASSESSMENT',
}
export const SORT_TYPE = {
  DESCENDING: 'DESC',
  ASCENDING: 'ASC',
}
export const DOCUMENT_TYPE = {
  INCOMING: 'INCOMING',
  OUTGOING: 'OUTGOING',
  ELEC_DOC: 'ELEC_DOC',
}

export const OUTGOING_DOCUMENT_STATUS = Object.freeze({
  SEND: {
    key: 'SEND',
    value: 'Chưa đọc',
  },
  SEEN: {
    key: 'SEEN',
    value: 'Đã đọc',
  },
  RECEIVED: {
    key: 'RECEIVED',
    value: 'Đã nhận',
  },
  PROCESSED: {
    key: 'PROCESSED',
    value: 'Đã xử lý',
  },
  REJECTED: {
    key: 'REJECTED',
    value: 'Đã từ chối',
  },
})
export const OUTGOING_DOCUMENT_STATE = Object.freeze({
  NEW: {
    key: 'NEW',
    value: 'Đã tạo mới',
  },
  UPDATE: {
    key: 'UPDATE',
    value: 'Đã chỉnh sửa',
  },
  CHANGE: {
    key: 'CHANGE',
    value: 'Thay đổi nơi nhận',
  },
  DELETE: {
    key: 'DELETE',
    value: 'Đã thu hồi',
  },
})

export const READ_STATUS = Object.freeze({
  READ: {
    key: 'READ',
    value: 'Đã xem',
  },
  UNREAD: {
    key: 'UNREAD',
    value: 'Chưa xem',
  },
})

export const DOCUMENT_ACCESS_TYPE = {
  VIEW_ALL: 'VIEW_ALL',
  UPDATE_RESULT: 'UPDATE_RESULT',
}

export const TASK_DOCUMENT_TYPE = {
  INCOMING: '001',
  OUTGOING: '002',
}

export const TASK_TYPE = Object.freeze({
  _001: {
    key: '001',
    value: 'Kiến nghị/Đề xuất NĐDPV/Doanh nghiệp',
  },
  _002: {
    key: '002',
    value: 'Tuyên bố Đại Lải',
  },
  _003: {
    key: '003',
    value: 'Nhiệm vụ khác',
  },
  _004: {
    key: '004',
    value: 'Nghị quyết HĐQT/KPI',
  },
  _005: {
    key: '005',
    value: 'Thông báo kết luận',
  },
})

export const TASK_TYPE_fromKey = strKey => {
  return TASK_TYPE[`_${strKey}`]
}

export const WORK_TYPE = Object.freeze({
  INTERNAL: 'Nội bộ trong Ban',
  CONSULT: 'Xin ý kiến các Ban',
  DOCUMENT: 'Từ văn bản',
  ELECTRONIC: 'Trình ký văn bản',
  DEPLOY: 'Từ nhiệm vụ',
  POLICY: 'Xin chủ trương',
  OTHER: 'Khác',
})

export const PAGE_NAME = {
  WORK: 'WORK',
  BUSINESS_TRIP: 'BUSINESS_TRIP',
}

export const PROPOSAL_TYPE = Object.freeze({
  BUSINESS_TRIP: { label: 'Đăng ký công tác', key: 'BUSINESS_TRIP' },
  LEAVE: { label: 'Đăng ký nghỉ phép', key: 'LEAVE' },
  LEAVE_ABNORMAL: {
    label: 'Đăng ký đi muộn về sớm',
    key: 'LEAVE_ABNORMAL',
  },
  LEAVE_NO_SALARY: {
    label: 'Đăng ký nghỉ phép không lương',
    key: 'LEAVE_NO_SALARY',
  },
  LEAVE_ANNUAL: { label: 'Đăng ký nghỉ phép hàng năm', key: 'LEAVE_ANNUAL' },
  SICK: { label: 'Đăng ký nghỉ ốm', key: 'SICK' },
  SICK_OTHER: { label: 'Đăng ký nghỉ chăm người thân ốm', key: 'SICK_OTHER' },
  OVERTIME_NORMAL: { label: 'Đăng ký làm thêm giờ', key: 'OVERTIME_NORMAL' },
  OVERTIME_DAYOFF: {
    label: 'Đăng ký làm thêm giờ ngày nghỉ',
    key: 'OVERTIME_DAYOFF',
  },
  OVERTIME_HOLIDAY: {
    label: 'Đăng ký làm thêm giờ ngày lễ',
    key: 'OVERTIME_HOLIDAY',
  },
  // OVERTIME_CHAIRMAN: {
  //   label: 'Đăng ký làm thêm giờ < Trưởng ban >',
  //   key: 'OVERTIME_CHAIRMAN',
  // },

  EVALUATE_MEMBER: {
    label: 'Đăng ký đánh giá cán bộ < Nhân viên >',
    key: 'EVALUATE_MEMBER',
  },
  EVALUATE_LEADER: {
    label: 'Đăng ký đánh giá cán bộ < Trưởng ban >',
    key: 'EVALUATE_LEADER',
  },
  TIMEKEEPER: { label: 'Tổng hợp chấm công', key: 'TIMEKEEPER' },
  //
  STATIONERY: { label: 'Đăng ký văn phòng phẩm', key: 'STATIONERY' },
  MEETING: { label: 'Giấy mời họp', key: 'MEETING' },
  VEHICLE: { label: 'Xin xe', key: 'VEHICLE' },
  RETIMEKEEPING: { label: 'Đăng ký chấm công bù', key: 'RETIMEKEEPING' },
})

export const SALARY_STATUS = {
  PENDING: 'PENDING', //Chờ duyệt
  TRUONG_BAN_APPROVED: 'TRUONG_BAN_APPROVED', //Trưởng ban duyệt
  TGD_APPROVED: 'TGD_APPROVED', //Tổng giám đốc duyệt
}
export const SALARY_TYPE = {
  MANAGER: 'MANAGER',
  EMPLOYEE: 'EMPLOYEE',
}
export const CONFIG_DOCUMENT_TYPE = {
  CONFIG_BOOK: 'CONFIG_BOOK',
  CONFIG_BOOK_GROUP: 'CONFIG_BOOK_GROUP',
}
export const CONFIG_PROPOSAL_TYPE = {
  CONFIG_PROPOSAL_TYPE: 'CONFIG_PROPOSAL_TYPE',
  CONFIG_PROPOSAL_TYPE_GROUP: 'CONFIG_PROPOSAL_TYPE_GROUP',
}
export const KPI_TYPE = {
  KPI: 'kpi',
  TARGET: 'target',
  SUB_TARGET: 'sub_target',
  WORK: 'work',
}
export const CLOUD_DOCUMENT_TYPE = {
  FOLDER: 0,
  FILE: 1,
}

export const INTERNAL_ASSESSMENT_STATUS = {
  PENDING: 'PENDING', //Chờ duyệt
  TRUONG_BAN_APPROVED: 'TRUONG_BAN_APPROVED',
  VP_APPROVED: 'VP_APPROVED', //văn phòng cho ý kiên
  BBT_APPROVED: 'BBT_APPROVED', //Ban biên tập cho ý kiến
  COMPLETED: 'COMPLETED',
}

export const ACL_TYPE = {
  DEFAULT: 'DEFAULT',
  CUSTOM: 'CUSTOM',
  CHU_KY_CUA_TOI: 'CHU_KY_CUA_TOI',
  INCOMING: 'INCOMING',
  INTERNAL_DOCUMENT: 'INTERNAL_DOCUMENT',
  ISO: 'ISO',
  KY_SO: 'KY_SO',
  LIEN_THONG_INCOMING: 'LIEN_THONG_INCOMING',
  LIEN_THONG_OUTGOING: 'LIEN_THONG_OUTGOING',
  LIEN_THONG_VB: 'LIEN_THONG_VB',
  MISSION: 'MISSION',
  MY_SALARY: 'MY_SALARY',
  NEWS: 'NEWS',
  NHOM_NGUOI_DUNG: 'NHOM_NGUOI_DUNG',
  NHOM_NHIEM_VU: 'NHOM_NHIEM_VU',
  OUTGOING: 'OUTGOING',
  PHAP_CHE: 'PHAP_CHE',
  PROPOSAL: 'PROPOSAL',
  PROPOSAL_ASSET: 'QUAN_LY_VAN_PHONG_PHAM',
  PROPOSAL_ADVANCE: 'PROPOSAL_ADVANCE',
  SALARY: 'SALARY',
  TAI_LIEU_DA_KY: 'TAI_LIEU_DA_KY',
  TIN_NHAN_LIEN_THONG: 'TIN_NHAN_LIEN_THONG',
  TIN_NHAN_NOI_BO: 'TIN_NHAN_NOI_BO',
  UBQLV: 'UBQLV',
  VAN_BAN_MAU: 'VAN_BAN_MAU',
  WORK: 'WORK',
  WORK_SCHEDULE: 'WORK_SCHEDULE',
  PHAT_HANH_VB: 'PHAT_HANH_VB',
  TAI_KHOAN_KY_SO: 'TAI_KHOAN_KY_SO',
  KPI: 'KPI',
  QUAN_LY_PHONG_BAN: 'QUAN_LY_PHONG_BAN',
  CHUC_DANH: 'CHUC_DANH',
  PKS_RUI_RO: 'PKS_RUI_RO',
  LOAI_HANH_CHINH: 'LOAI_HANH_CHINH',
  NHOM_LOAI_HANH_CHINH: 'NHOM_LOAI_HANH_CHINH',
  BAO_CAO: 'BAO_CAO',
  QUY_TRINH_MUA_SAM: 'QUY_TRINH_MUA_SAM',
  MENU_OUTSIDE: 'MENU_OUTSIDE',
  INTERNAL_ASSESSMENT: 'INTERNAL_ASSESSMENT',
  LICH_LAM_VIEC_CA_NHAN: 'LICH_LAM_VIEC_CA_NHAN',
  LICH_LAM_VIEC_PHONG_BAN: 'LICH_LAM_VIEC_PHONG_BAN',
}
export const ACL_ACTION_TYPE = {
  // CHU_KY_CUA_TOI
  create__CHU_KY_CUA_TOI: 'create__CHU_KY_CUA_TOI',
  delete__CHU_KY_CUA_TOI: 'delete__CHU_KY_CUA_TOI',
  // TAI_KHOAN_KY_SO
  menu__TAI_KHOAN_KY_SO: 'menu__TAI_KHOAN_KY_SO',
  create__TAI_KHOAN_KY_SO: 'create__TAI_KHOAN_KY_SO',
  edit__TAI_KHOAN_KY_SO: 'edit__TAI_KHOAN_KY_SO',
  delete__TAI_KHOAN_KY_SO: 'delete__TAI_KHOAN_KY_SO',
  // INCOMING
  edit__INCOMING: 'edit__INCOMING',
  xuly__INCOMING: 'xuly__INCOMING',
  history__INCOMING: 'history__INCOMING',
  history__OUTGOING: 'history__OUTGOING',
  create__INCOMING: 'create__INCOMING',
  delete__INCOMING: 'delete__INCOMING',
  phanphat__INCOMING: 'phanphat__INCOMING',
  tao_nv_tu_vb__INCOMING: 'tao_nv_tu_vb__INCOMING',
  tao_cv_tu_vb__INCOMING: 'tao_cv_tu_vb__INCOMING',
  ky_so__INCOMING: 'ky_so__INCOMING',
  // INTERNAL_DOCUMENT
  menu__INTERNAL_DOCUMENT: 'menu__INTERNAL_DOCUMENT',
  tab_vb_di__INTERNAL_DOCUMENT: 'tab_vb_di__INTERNAL_DOCUMENT',
  tab_vb_den__INTERNAL_DOCUMENT: 'tab_vb_den__INTERNAL_DOCUMENT',
  tab_cau_hinh_vb__INTERNAL_DOCUMENT: 'tab_cau_hinh_vb__INTERNAL_DOCUMENT',
  tab_phat_hanh_vb__INTERNAL_DOCUMENT: 'tab_phat_hanh_vb__INTERNAL_DOCUMENT',
  // INTERNAL_ASSESSMENT
  create__INTERNAL_ASSESSMENT: 'create__INTERNAL_ASSESSMENT',
  delete__INTERNAL_ASSESSMENT: 'delete__INTERNAL_ASSESSMENT',
  edit__INTERNAL_ASSESSMENT: 'edit__INTERNAL_ASSESSMENT',
  add_people__INTERNAL_ASSESSMENT: 'add_people__INTERNAL_ASSESSMENT',
  menu__INTERNAL_ASSESSMENT: 'menu__INTERNAL_ASSESSMENT',
  // ISO
  menu__ISO: 'menu__ISO',
  create__ISO: 'create__ISO',
  delete__ISO: 'delete__ISO',
  upload__ISO: 'upload__ISO',
  rename__ISO: 'rename__ISO',
  move__ISO: 'move__ISO',
  //
  menu__KY_SO: 'menu__KY_SO',
  // KY_SO
  tab_quan_ly__KY_SO: 'tab_quan_ly__KY_SO',
  tab_tai_lieu__KY_SO: 'tab_tai_lieu__KY_SO',
  tab_chu_ky_so_cua_toi__KY_SO: 'tab_chu_ky_so_cua_toi__KY_SO',
  // LIEN_THONG_INCOMING
  delete__LIEN_THONG_INCOMING: 'delete__LIEN_THONG_INCOMING',
  receive__LIEN_THONG_INCOMING: 'receive__LIEN_THONG_INCOMING',
  // LIEN_THONG_OUTGOING
  edit__LIEN_THONG_OUTGOING: 'edit__LIEN_THONG_OUTGOING',
  create__LIEN_THONG_OUTGOING: 'create__LIEN_THONG_OUTGOING',
  delete__LIEN_THONG_OUTGOING: 'delete__LIEN_THONG_OUTGOING',
  // LIEN_THONG_VB
  menu__LIEN_THONG_VB: 'menu__LIEN_THONG_VB',
  tab_vb_di__LIEN_THONG_VB: 'tab_vb_di__LIEN_THONG_VB',
  tab_vb_den__LIEN_THONG_VB: 'tab_vb_den__LIEN_THONG_VB',
  // MISSION
  edit__MISSION: 'edit__MISSION',
  menu__MISSION: 'menu__MISSION',
  create__MISSION: 'create__MISSION',
  delete__MISSION: 'delete__MISSION',
  cap_nhat__MISSION: 'cap_nhat__MISSION',
  create_work__MISSION: 'create_work__MISSION',
  bang_tong_hop__MISSION: 'bang_tong_hop__MISSION',
  hien_thi_full__MISSION: 'hien_thi_full__MISSION',
  chuyen_sang_thang__MISSION: 'chuyen_sang_thang__MISSION',
  lanh_dao__MISSION: 'lanh_dao__MISSION',
  // NEWS
  edit__NEWS: 'edit__NEWS',
  menu__NEWS: 'menu__NEWS',
  create__NEWS: 'create__NEWS',
  delete__NEWS: 'delete__NEWS',
  // OUTGOING
  edit__OUTGOING: 'edit__OUTGOING',
  xuly__OUTGOING: 'xuly__OUTGOING',
  create__OUTGOING: 'create__OUTGOING',
  delete__OUTGOING: 'delete__OUTGOING',
  phanphat__OUTGOING: 'phanphat__OUTGOING',
  lienthong_vimc__OUTGOING: 'lienthong_vimc__OUTGOING',
  lienthong_ubqlv__OUTGOING: 'lienthong_ubqlv__OUTGOING',
  tao_nv_tu_vb__OUTGOING: 'tao_nv_tu_vb__OUTGOING',
  tao_cv_tu_vb__OUTGOING: 'tao_cv_tu_vb__OUTGOING',
  ky_so__OUTGOING: 'ky_so__OUTGOING',
  // PHAP_CHE
  edit__PHAP_CHE: 'edit__PHAP_CHE',
  menu__PHAP_CHE: 'menu__PHAP_CHE',
  create__PHAP_CHE: 'create__PHAP_CHE',
  delete__PHAP_CHE: 'delete__PHAP_CHE',
  // PROPOSAL
  menu__PROPOSAL: 'menu__PROPOSAL',
  create__PROPOSAL: 'create__PROPOSAL',
  delete__PROPOSAL: 'delete__PROPOSAL',
  approve__PROPOSAL: 'approve__PROPOSAL',
  administration_PROPOSAL: 'administration_PROPOSAL',
  menu__PHAN_PHAT: 'menu__PHAN_PHAT',
  // PHIEU_PHAN_PHAT_VAN_PHONG_PHAM
  menu__PHAN_PHAT_VAN_PHONG_PHAM: 'menu__QUAN_LY_VAN_PHONG_PHAM',
  create__PROPOSAL__ASSET: 'create__PROPOSAL_ASSET',
  delete__PROPOSAL__ASSET: 'delete__PROPOSAL_ASSET',
  approve__PROPOSAL__ASSET: 'approve__PROPOSAL_ASSET',
  edit__PROPOSAL__ASSET: 'edit__PROPOSAL_ASSET',
  manage_type__QUAN_LY_KHO: 'manage_type__QUAN_LY_KHO',
  // QUAN LY KHO
  menu__QUAN_LY_KHO: 'sub_menu__QUAN_LY_KHO',
  // SALARY
  menu__SALARY: 'menu__SALARY',
  create__SALARY: 'create__SALARY',
  delete__SALARY: 'delete__SALARY',
  approve__SALARY: 'approve__SALARY',
  menu_outside__SALARY: 'menu_outside__SALARY',
  // TAI_LIEU_DA_KY
  create__TAI_LIEU_DA_KY: 'create__TAI_LIEU_DA_KY',
  delete__TAI_LIEU_DA_KY: 'delete__TAI_LIEU_DA_KY',
  download__TAI_LIEU_DA_KY: 'download__TAI_LIEU_DA_KY',
  // TIN_NHAN_LIEN_THONG
  menu__TIN_NHAN_LIEN_THONG: 'menu__TIN_NHAN_LIEN_THONG',
  send__TIN_NHAN_LIEN_THONG: 'send__TIN_NHAN_LIEN_THONG',
  // TIN_NHAN_NOI_BO
  menu__TIN_NHAN_NOI_BO: 'menu__TIN_NHAN_NOI_BO',
  send__TIN_NHAN_NOI_BO: 'send__TIN_NHAN_NOI_BO',
  // UBQLV
  menu__UBQLV: 'menu__UBQLV',
  tab_vb_di__UBQLV: 'tab_vb_di__UBQLV',
  tab_vb_den__UBQLV: 'tab_vb_den__UBQLV',
  tab_cty__UBQLV: 'tab_cty__UBQLV',
  // WORK
  edit__WORK: 'edit__WORK',
  menu__WORK: 'menu__WORK',
  create__WORK: 'create__WORK',
  delete__WORK: 'delete__WORK',
  uu_tien__WORK: 'uu_tien__WORK',
  phat_hanh__WORK: 'phat_hanh__WORK',
  them_nguoi__WORK: 'them_nguoi__WORK',
  them_cong_viec_phu__WORK: 'them_cong_viec_phu__WORK',
  cap_nhat_trang_thai__WORK: 'cap_nhat_trang_thai__WORK',
  sua_cong_viec_phu__WORK: 'sua_cong_viec_phu__WORK',
  xoa_cong_viec_phu__WORK: 'xoa_cong_viec_phu__WORK',
  menu_outside__WORK: 'menu_outside__WORK',
  // WORK_SCHEDULE
  edit__WORK_SCHEDULE: 'edit__WORK_SCHEDULE',
  menu__WORK_SCHEDULE: 'menu__WORK_SCHEDULE',
  create__WORK_SCHEDULE: 'create__WORK_SCHEDULE',
  delete__WORK_SCHEDULE: 'delete__WORK_SCHEDULE',
  view_dashboard__WORK_SCHEDULE: 'view_dashboard__WORK_SCHEDULE',
  // MY_SALARY
  menu__MY_SALARY: 'menu__MY_SALARY',
  // NHOM_NGUOI_DUNG
  menu__NHOM_NGUOI_DUNG: 'menu__NHOM_NGUOI_DUNG',
  create__NHOM_NGUOI_DUNG: 'create__NHOM_NGUOI_DUNG',
  edit__NHOM_NGUOI_DUNG: 'edit__NHOM_NGUOI_DUNG',
  delete__NHOM_NGUOI_DUNG: 'delete__NHOM_NGUOI_DUNG',
  remove_member__NHOM_NGUOI_DUNG: 'remove_member__NHOM_NGUOI_DUNG',
  // NHOM_NHIEM_VU
  menu__NHOM_NHIEM_VU: 'menu__NHOM_NHIEM_VU',
  create__NHOM_NHIEM_VU: 'create__NHOM_NHIEM_VU',
  edit__NHOM_NHIEM_VU: 'edit__NHOM_NHIEM_VU',
  delete__NHOM_NHIEM_VU: 'delete__NHOM_NHIEM_VU',
  remove_member__NHOM_NHIEM_VU: 'remove_member__NHOM_NHIEM_VU',
  // PROPOSAL_ADVANCE
  menu__PROPOSAL_ADVANCE: 'menu__PROPOSAL_ADVANCE',
  create__PROPOSAL_ADVANCE: 'create__PROPOSAL_ADVANCE',
  approve__PROPOSAL_ADVANCE: 'approve__PROPOSAL_ADVANCE',
  delete__PROPOSAL_ADVANCE: 'delete__PROPOSAL_ADVANCE',
  // VAN_BAN_MAU
  menu__VAN_BAN_MAU: 'menu__VAN_BAN_MAU',
  create__VAN_BAN_MAU: 'create__VAN_BAN_MAU',
  edit__VAN_BAN_MAU: 'edit__VAN_BAN_MAU',
  delete__VAN_BAN_MAU: 'delete__VAN_BAN_MAU',
  // PHAT_HANH_VB
  van_thu_duyet__PHAT_HANH_VB: 'van_thu_duyet__PHAT_HANH_VB',
  lanh_dao_duyet__PHAT_HANH_VB: 'lanh_dao_duyet__PHAT_HANH_VB',
  cap_so__PHAT_HANH_VB: 'cap_so__PHAT_HANH_VB',
  lanh_dao_huy_duyet__PHAT_HANH_VB: 'lanh_dao_huy_duyet__PHAT_HANH_VB',
  ky_so_tai_lieu__PHAT_HANH_VB: 'ky_so_tai_lieu__PHAT_HANH_VB',
  phat_hanh_tai_lieu__PHAT_HANH_VB: 'phat_hanh_tai_lieu__PHAT_HANH_VB',
  delete__PHAT_HANH_VB: 'delete__PHAT_HANH_VB',
  create__PHAT_HANH_VB: 'create__PHAT_HANH_VB',
  // BI
  menu__BAO_CAO: 'menu__BAO_CAO',
  // KPI
  menu__KPI: 'menu__KPI',
  create__KPI: 'create__KPI',
  edit__KPI: 'edit__KPI',
  delete__KPI: 'delete__KPI',
  // QUAN LY PHONG BAN
  menu__QUAN_LY_PHONG_BAN: 'menu__QUAN_LY_PHONG_BAN',
  create__QUAN_LY_PHONG_BAN: 'create__QUAN_LY_PHONG_BAN',
  edit__QUAN_LY_PHONG_BAN: 'edit__QUAN_LY_PHONG_BAN',
  delete__QUAN_LY_PHONG_BAN: 'delete__QUAN_LY_PHONG_BAN',
  sort__QUAN_LY_PHONG_BAN: 'sort__QUAN_LY_PHONG_BAN',
  create_employee__QUAN_LY_PHONG_BAN: 'create_employee__QUAN_LY_PHONG_BAN',
  edit_employee__QUAN_LY_PHONG_BAN: 'edit_employee__QUAN_LY_PHONG_BAN',
  // CHUC DANH
  menu__CHUC_DANH: 'menu__CHUC_DANH',
  create__CHUC_DANH: 'create__CHUC_DANH',
  edit__CHUC_DANH: 'edit__CHUC_DANH',
  view__CHUC_DANH: 'view__CHUC_DANH',
  delete__CHUC_DANH: 'delete__CHUC_DANH',
  sort__CHUC_DANH: 'sort__CHUC_DANH',
  // PHIEU KIEM SOAT RUI RO
  create__PKS_RUI_RO: 'create__PKS_RUI_RO',
  menu__PKS_RUI_RO: 'menu__PKS_RUI_RO',
  delete__PKS_RUI_RO: 'delete__PKS_RUI_RO',
  baoCao__PKS_RUI_RO: 'baoCao__PKS_RUI_RO',
  quanTri__PKS_RUI_RO: 'quanTri__PKS_RUI_RO',
  access__PKS_RUI_RO: 'access__PKS_RUI_RO',
  create__baocao__PKS_RUI_RO: 'create__baocao__PKS_RUI_RO',
  update__baocao__PKS_RUI_RO: 'update__baocao__PKS_RUI_RO',
  delete__baocao__PKS_RUI_RO: 'delete__baocao__PKS_RUI_RO',
  //LOAI_HANH_CHINH
  menu__LOAI_HANH_CHINH: 'menu__LOAI_HANH_CHINH',
  tab_ch_loai_hanh_chinh__LOAI_HANH_CHINH:
    'tab_ch_loai_hanh_chinh__LOAI_HANH_CHINH',
  create__LOAI_HANH_CHINH: 'create__LOAI_HANH_CHINH',
  edit__LOAI_HANH_CHINH: 'edit__LOAI_HANH_CHINH',
  delete__LOAI_HANH_CHINH: 'delete__LOAI_HANH_CHINH',
  //NHOM_LOAI_HANH_CHINH
  tab_ch_nhom_loai_hanh_chinh__LOAI_HANH_CHINH:
    'tab_ch_nhom_loai_hanh_chinh__LOAI_HANH_CHINH',
  create__NHOM_LOAI_HANH_CHINH: 'create__LOAI_HANH_CHINH',
  edit__NHOM_LOAI_HANH_CHINH: 'edit__LOAI_HANH_CHINH',
  delete__NHOM_LOAI_HANH_CHINH: 'delete__LOAI_HANH_CHINH',
  // Quy trình mua sắm
  menu__QUY_TRINH_MUA_SAM: 'menu__QUY_TRINH_MUA_SAM',
  create__QUY_TRINH_MUA_SAM: 'create__QUY_TRINH_MUA_SAM',
  delete__QUY_TRINH_MUA_SAM: 'delete__QUY_TRINH_MUA_SAM',
  approve__QUY_TRINH_MUA_SAM: 'approve__QUY_TRINH_MUA_SAM',
  //Menu hệ thống
  menu__UTILITY: 'menu__UTILITY',
  menu__ADMIN: 'menu__ADMIN',
  menu_HOME_PAGE: 'menu_HOME_PAGE',
  menu__VAN_BAN: 'menu__VAN_BAN',
  // Lịch làm việc cá nhân
  menu__LICH_LAM_VIEC_CA_NHAN: 'menu__LICH_LAM_VIEC_CA_NHAN',
  menu__LICH_LAM_VIEC_PHONG_BAN: 'menu__LICH_LAM_VIEC_PHONG_BAN',
}
export const MODULE_CODE = {
  // -- văn bản
  van_ban: 'van_ban',
  van_ban_noi_bo: 'van_ban_noi_bo',
  lien_thong_van_ban: 'lien_thong_van_ban',
  lien_thong_van_ban_ubqlv: 'lien_thong_van_ban_ubqlv',
  so_van_ban: 'so_van_ban',
  van_ban_mau: 'van_ban_mau',
  co_quan_ban_hanh: 'co_quan_ban_hanh',
  // -- phiếu đánh giá nội bộ
  phieu_danh_gia_noi_bo: 'phieu_danh_gia_noi_bo',
  // -- nhiệm vụ
  nhiem_vu: 'nhiem_vu',
  tin_nhan_lien_thong: 'tin_nhan_lien_thong',
  tin_nhan_noi_bo: 'tin_nhan_noi_bo',
  // -- công việc
  cong_viec: 'cong_viec',
  // -- lịch cơ quan
  lich_co_quan: 'lich_co_quan',
  // -- bảng lương
  bang_luong: 'bang_luong',
  duyet_luong: 'duyet_luong',
  luong_cua_toi: 'luong_cua_toi',
  // -- hành chính
  hanh_chinh: 'hanh_chinh',
  sub_hanh_chinh: 'sub_hanh_chinh',
  phieu_rui_ro: 'phieu_rui_ro',
  tam_ung: 'tam_ung',
  // -- ký số
  ky_so: 'ky_so',
  tai_khoan_ky_so: 'tai_khoan_ky_so',
  // -- quản trị
  quan_tri: 'quan_tri',
  nhom_nguoi_dung: 'nhom_nguoi_dung',
  nhom_nhiem_vu: 'nhom_nhiem_vu',
  nguoi_dung: 'nguoi_dung',
  phong_ban: 'phong_ban',
  chuc_danh: 'chuc_danh',
  // -- tiện ích
  tien_ich: 'tien_ich',
  tai_lieu_iso: 'tai_lieu_iso',
  vb_phap_che: 'vb_phap_che',
  thong_bao_chung: 'thong_bao_chung',
  // -- phiếu phân phát văn phòng phẩm
  ql_van_phong_pham: 'ql_van_phong_pham',
  sub_ql_van_phong_pham: 'sub_ql_van_phong_pham',
  phieu_phan_phat_vpp: 'phieu_phan_phat_vpp',
  quan_ly_kho: 'quan_ly_kho',
  // -- kpi
  kpi: 'kpi',
  bi: 'bi',
  //--Công việc
  ql_cong_viec: 'ql_cong_viec',
  sub_ql_cong_viec: 'sub_ql_cong_viec',
  quy_trinh_mua_sam: 'quy_trinh_mua_sam',
  //---Lịch làm việc
  lich_lam_viec: 'lich_lam_viec',
  lich_lam_viec_ca_nhan: 'lich_lam_viec_ca_nhan',
  lich_lam_viec_phong_ban: 'lich_lam_viec_phong_ban',
}

export const RISK_TYPE = {
  DELEGATE: 'NDDPV',
  UNIT: 'DVPT',
  AGENCY: 'CQVP',
}

export const VIEWLOG_DATE = {
  work_read_until: '2023-01-14',
  internal_document_until: '2022-12-28',
}

export const REPORT_TYPE = {
  PERIODICAL_REPORT: 'DINH_KY',
  UNUSUAL_REPORT: 'DOT_XUAT',
}

export const ERROR_CODE_MESSAGE = Object.freeze({
  'USER-106': 'Mật khẩu đã hết hạn, vui lòng thay đổi mật khẩu!',
  'USER-107': 'Mật khẩu mới không được trùng với 3 mật khẩu gần nhất!',
})

export const SHIFTS = Object.freeze({
  ALL_DAY: {
    key: 'allDay',
    value: 'Cả ngày',
  },
  MORNING: {
    key: 'morning',
    value: 'Buổi sáng',
  },
  AFTERNOON: {
    key: 'afternoon',
    value: 'Buổi chiều',
  },
  EMPTY: {
    key: '',
    value: '<Bỏ qua>',
  },
})

export const MODES = Object.freeze({
  NORMAL: {
    key: 'normal',
    value: 'Thông thường',
  },
  SPECIAL: {
    key: 'special',
    value: 'Chế độ',
  },
  WOMEN: {
    key: 'women',
    value: 'Chế độ phụ nữ',
  },
  CHILD_CARE: {
    key: 'child_care',
    value: 'Chế độ nuôi con nhỏ',
  },
  WORK_REASON: {
    key: 'work_reason',
    value: 'Lý do công việc',
  },
  BY_REGIME: {
    key: 'by_regime',
    value: 'Theo chế độ',
  },
})
